import { useDebounce } from "@hopper-ui/components";
import { useCallback, useState } from "react";

const SEARCH_DEBOUNCE_MS = 300;

export interface DebouncedSearchQuery {
    query: string;
    debouncedQuery: string;
    setQuery: (value: string) => void;
    setQueryNow: (value: string) => void;
    reset: () => void;
}

export function useDebouncedSearchQuery() {
    const [query, setQuery] = useState("");
    const [debouncedQuery, scheduleDebouncedQuery, applyDebouncedQueryNow] = useDebounce("", SEARCH_DEBOUNCE_MS);

    const handleQueryChange = useCallback(
        (value: string) => {
            setQuery(value);
            scheduleDebouncedQuery(value);
        },
        [scheduleDebouncedQuery]
    );

    const setQueryNow = useCallback(
        (value: string) => {
            setQuery(value);
            applyDebouncedQueryNow(value);
            scheduleDebouncedQuery(value);
        },
        [scheduleDebouncedQuery, applyDebouncedQueryNow]
    );

    const reset = useCallback(() => setQueryNow(""), [setQueryNow]);

    return { query, debouncedQuery, setQuery: handleQueryChange, setQueryNow, reset };
}
